import { FC, SyntheticEvent, useCallback } from 'react';
import { Jane } from 'types/graphql';
import { BKJAvatar, BKJCheckbox } from '@awais4123/fillify-design-library';
import {
  AvatarIconWrapper,
  JaneSelect,
} from 'pages/SettingsPage/modals/GroupsModal/components/SearchTeamMembersGroups/SearchTeamMembersGroups.styled';
import { ListItemWrapper } from '@awais4123/fillify-design-library/lib/components/BKJListItem/BKJListItem.styled';
import { Flex } from 'components/Flex';
import { StyledBKJIcon } from 'components/JaneGridSelect/JaneGridSelect.styled';
import { BKJIcon } from '@awais4123/fillify-design-library';

interface ITeamMemberOption {
  node: Jane;
  value: string;
  name: string;
  isChecked: boolean;
  onSelect: (e: unknown) => void;
  showGroupIcon?: boolean;
}

export const TeamMemberOption: FC<ITeamMemberOption> = ({
  node,
  value,
  isChecked,
  name,
  onSelect,
  showGroupIcon,
}) => {
  const fullName = `${node?.firstName} ${node?.lastName}`;

  const handleClick = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault && event.preventDefault();
      onSelect({
        ...event,
        target: {
          ...event.target,
          node: { ...node },
          isChecked,
        },
      });
    },
    [isChecked, node, onSelect],
  );

  return (
    <JaneSelect key={node.id} alignItems="center" selected={false}>
      <ListItemWrapper
        variant="RowReverseSpaceBetween"
        role="listbox"
        onClick={handleClick}
        checked={isChecked}
      >
        <Flex width="100%" flexDirection="row" alignItems="center" gap="8px;">
          <BKJCheckbox variant="GreenSolid" value={isChecked} />
          <AvatarIconWrapper>
            <BKJAvatar
              src={node.avatarUrls.small}
              width="30px"
              height="30px"
              fallbackAvatarColor="Grey4"
            />
            {node?.pendingSignup && (
              <StyledBKJIcon iconName="PendingSignup" left="17" top="16" width="20" />
            )}
          </AvatarIconWrapper>
          <span>{fullName}</span>
          {showGroupIcon && <BKJIcon iconName="Group2" width={16} height={14} />}
        </Flex>
      </ListItemWrapper>
    </JaneSelect>
  );
};
